<template>
  <header>
      <div class="overlay">
        <p class="copyp">photos: Elia Kuhn</p>
        <div class="navbar">
          <ul>
            <li class="onglet">
              <router-link tag="a" to="/">accueil</router-link>
            </li>
            <li class="onglet">
              <router-link tag="a" to="/temoignages">témoignages</router-link>
            </li>
            <li class="onglet">
              <router-link tag="a" to="/tarifs">tarifs</router-link>
            </li>
            <li class="onglet">
              <router-link tag="a" to="/contact">contact</router-link>
            </li>
          </ul>
        </div>
        <h1>Roxane Delanoé</h1>
        <h2>Kinésiologie (MKB) - Soins énergétiques (Bars)</h2>
      </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent'
}
</script>

<style scoped>
header {
    margin: 20px;
    width: auto;
    /* height: 40vh; */
    background: url('../assets/img/bg.jpg');
    background-position-x: 35%;
    background-position-y: bottom;
    font-family: Avenir, "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.overlay {
  background: rgba(0,0,0,.4);
  width: 100%;
  height: 100%;
}

header > .overlay > h1 {
  color: white;
  margin: 0;
  font-family: 'Quintessential', cursive;
  font-weight: normal;
  text-align: center;
  font-size: 5em;
  margin-right: -20px;
}

header > .overlay > h2 {
  color: white;
  opacity: .85;
  margin: 0;
  font-family: 'Quintessential', cursive;
  font-weight: normal;
  text-align: center;
  font-size: 1.5em;
  margin-bottom: 80px;
  margin-right: -20px;
}

header > .overlay > .navbar {
  margin-bottom: 2em;
}

header > .overlay > .navbar > ul {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1.5em 3em;
}

header > .overlay > .navbar > ul > li {
  list-style: none;
  font-size: 1.4em;
}

@media screen and (max-width: 900px) {
  header > .overlay > .navbar > ul {
    flex-direction: column!important;
    align-items: center;
  }
  header > .overlay > h1 {
    font-size: 3em;
  }
  header > .overlay > h2 {
    font-size: 1em;
  }
}

.copyp {
  position: absolute;
  right: 5px;
  line-height: 1em;
  transform: rotate(-90deg);
  transform-origin: 100% 100%;
  top: 10px;
  font-size: 10px;
}
</style>
